import View from './LogDetails';
import enhancer from './LogDetails.enhancer';

export default enhancer(View);
